/* eslint-disable react/jsx-props-no-spreading */
import { create as createHydrator } from 'mobx-persist';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactGA from 'react-ga4';
import mainStore from './mobx/mainStore';
import cookies from './services/cookie';
import logger from './services/logger';
import RootView from './view/RootView';
import { appStore } from './mobx/appStore';

export default class App extends React.Component<{}> {
  state = {
    loading: true,
  };

  componentDidMount = async () => {
    if (process.env.REACT_APP_GOOGLE_ANALYTICS) {
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
    }

    if (window.IS_MOBILE) {
      cookies.setCookie('is_new_admin', '1');
    }
    await this.loadSources();
    appStore.runCheckUpdates();
  };

  private loadSources = async () => {
    try {
      this.setState({ loading: true });
      await this.hydrateStores();
      this.setState({ loading: false });
    } catch (error: any) {
      logger.error({ error, place: 'App loadSources' });
      this.setState({ loading: false });
    }
  };

  private hydrate = createHydrator({
    storage: localStorage,
    jsonify: true,
  });

  private hydrateStores = async () => {
    // hydrate all stores
    await Promise.all(
      Object.entries(mainStore).map(async ([key, store]) => {
        if (!store) return;
        await this.hydrate(key, store);

        if (store.afterHydration) {
          await store.afterHydration();
        }
      })
    );
  };

  componentWillUnmount(): void {
    appStore.stopCheckUpdates();
  }

  public render() {
    if (this.state.loading) return <h1>LOADING</h1>;

    return (
      <Provider {...mainStore}>
        <RootView />
      </Provider>
    );
  }
}
